import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
	errorMsg: '',
};

export const errorHandlingSlice = createSlice({
	name: 'errorHandling',
	initialState,
	reducers: {
		setErrorMsg: (state, action) => {
			state.errorMsg = action.payload;
		},
		setEmptyErrorMsg: (state) => {
			state.errorMsg = '';
		},
	},
});

export const { setErrorMsg, setEmptyErrorMsg } = errorHandlingSlice.actions;

export default errorHandlingSlice.reducer;
